import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CheckoutFormService } from '../../checkout-form-service/checkout-form.service';

@Component({
    selector: 'ols-guest-client',
    templateUrl: './guest-client.component.html',
    styleUrls: ['./guest-client.component.scss'],
})
export class GuestClientComponent implements OnInit {
    @Input() isLoading: boolean;
    @Input() purchaseAgreement: string;
    @Input() surchargeSettings: {
        surchargeEnabled: boolean;
        surchargeRate: number;
    };
    @Input() summary: any;

    form: FormGroup;

    constructor(private formService: CheckoutFormService) {}

    ngOnInit(): void {
        this.form = this.formService.createNewCardForm(false);
    }
}
